export default __webpack_public_path__ + "static/media/z-1-character-animating.6d4cb8f0.svg";